import React, {useEffect, useState} from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import {FormGrid} from "../../checkout/components/billingData/DataForm";
import {ArrowDownward} from "@mui/icons-material";

function PromoCodeEditor({obj, onChange}) {
    const [code, setCode] = useState('');
    const [editableObj, setEditableObj] = useState(obj);

    useEffect(() => {
        setEditableObj(obj);
    }, [obj]);

    const addNewCode = () => {
        if (code.trim()) {
            const newObj = Object.assign({}, obj);
            newObj[code.trim()] = {value: 0};
            onChange(newObj);
            setCode('');
        }
    }

    const onDelete = (key) => {
        const newObj = Object.assign({}, obj);
        delete newObj[key];
        onChange(newObj);
    }

    const onCodePropChange = (key, property, value) => {
        editableObj[key][property] = value;
        setEditableObj({...editableObj});
    }

    const onCodeSubmit = (key) => {
        const newObj = Object.assign({}, obj);
        newObj[key] = editableObj[key];
        onChange(newObj);
    }

    return (
        <div className="promoeditor">
            {Object.keys(obj || {}).map(key => <Accordion>
                <AccordionSummary
                    expandIcon={<ArrowDownward/>}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                <Typography>
                    {key}
                </Typography>
                    <Button onClick={() => onDelete(key)}>Delete</Button>
                </AccordionSummary>
                <AccordionDetails>
                    {Object.keys(editableObj[key] || {}).map(property => <FormGrid sx={{pb: 3}}>
                        <FormLabel htmlFor={property} required>
                            {property}
                        </FormLabel>
                        <TextField
                            id={property}
                            name={property}
                            type="text"
                            placeholder={property}
                            required
                            size="small"
                            value={editableObj[key][property]}
                            onChange={(event) => onCodePropChange(key, property, event.target.value)}
                        />
                    </FormGrid>)}
                    <Button onClick={() => onCodeSubmit(key)}>Submit</Button>
                </AccordionDetails>



            </Accordion>)}
            <FormGrid size={{xs: 12}} sx={{pt: 3}}>
                <FormLabel htmlFor="code" required>
                    New code:
                </FormLabel>
                <TextField
                    id="code"
                    name="code"
                    type="text"
                    placeholder={"Code"}
                    required
                    size="small"
                    value={code}
                    onChange={(event) => setCode(event.target.value)}
                />
            </FormGrid>
            <Button onClick={addNewCode}>Add new code</Button>
        </div>
    );
}

export default PromoCodeEditor;
